export enum FUNNEL_TYPES {
  signup = "signup",
  login = "login",
  authentication = "authentication",
  signupEmailPassword = "signup-email-password",
  donate = "donate",
  donateConfirmation = "donate-confirmation",
  subscription = "subscription",
  offerPaywall = "offer-paywall",
  pdf = "pdf",
  downloadPdf = "download-pdf",
  addToLibrary = "add-to-library",
  onboarding = "onboarding",
  purchaseRelease = "purchase-release",
  purchaseBundle = "purchase-bundle",
  prePaywall = "pre-paywall",
  congrats = "congrats",
  blackFridayCongrats = "black-friday-congrats",
  holidayBundleCongrats = "holiday-bundle-congrats",
  goldAccess = "gold-access",
  changeUsername = "change-username",
  purchasePod = "purchase-pod",
  purchasePodConfirmation = "purchase-pod-confirmation",
}
